export default{
    lista:{
        method:'get',
        url:'trabalhador/auto/lista'
    },
    listatrabalhador:{
        method:'get',
        url:'trabalhador/pesquisa{/id}'
    },
    listatomador:{
        method:'get',
        url:'tomador/lista'
    },
    cadastra:{
        method:'post',
        url:'trabalhador/auto/cadastro'
    },
    delete:{
        method:'delete',
        url:'comissionado/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'comissionado/editar{/id}'
    },
    update:{
        method:'post',
        url:'comissionado/update'
    }
}
